import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './styles/main.scss';
import { App } from './app/App';
import { ErrorBoundary } from './app/ErrorBoundary';
import { startMarketDataRuntime } from './data/client/marketDataRuntime';

startMarketDataRuntime();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
